import { useState } from 'react';
import CommonTabContent from '../../../components/common-tab-content';

const options = ['Generate email subject', 'Generate email body', 'Generate code', 'Generate SQL query', 'Test cases'];

interface PromptText {
	[key: number]: string;
}

const promptText: PromptText = {
	0: 'Generate an appropriate subject line for the given email text. Output only the subject line, with no accompanying message.',
	1: 'Generate a body for an email based on the given text. Output only the email body, with no additional information. Provide output in markdown format.',
	2: 'Generate code based on the given requirements. Ensure the code is properly formatted and commented to ensure it is easy to read and understand. Output only the code and its comments, with no additional explanation. Provide output in markdown format.',
	3: 'Generate a SQL query based on the given requirements. Output only the final SQL query, with no accompanying message.',
	4: "Analyze the given code, and generate test cases to verify it. Output a list of sample inputs for the given code's parameters, and an expected output for each set of inputs. Each test case must be unique. Limit output to 10 test cases. Output only a list of inputs and expected outputs, with each case on a new line. Provide output in markdown format.",
};

const GenerateTabContent: React.FC = () => {
	const [promptValue, setPromptValue] = useState<string>(promptText[0]);

	const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const selectedOptionIndex = parseInt(e.target.value);
		setPromptValue(promptText[selectedOptionIndex]);
	};

	return (
		<div className="max-w-2xl">
			<div className="mb-4">
				<select
					className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-600 sm:text-sm sm:leading-6"
					onChange={handleSelectChange}
				>
					{options.map((item, index) => (
						<option key={index} value={index}>
							{item}
						</option>
					))}
				</select>
			</div>
			<CommonTabContent defaultPrompt={promptValue} />
		</div>
	);
};

export default GenerateTabContent;
